import { ProjectManagementProjectsListPageDuplicateProjectModalPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import DuplicateProjectModal from 'modules/project_management/components/modals/DuplicateProjectModal'

const DuplicateProjectModalPage = () => {
  const { data, loading: loadingPolicies } = useQuery(
    ProjectManagementProjectsListPageDuplicateProjectModalPageDocument
  )

  if (!data && loadingPolicies) return null

  const canCreateProject = data?.projectManagement._policies.projectCreate.can ?? false
  if (!canCreateProject) return null

  return <DuplicateProjectModal />
}

export default DuplicateProjectModalPage
